define('widgets/dgrid/blocks/trophies/trophies',[
   'underscore',
   'knockout'
], function (_, ko) {

    var TrophiesBlock = function (session, adventurers, dialog, TrophiesDialog, adventureFieldFetcher) {
        var self = this;
        self.playerIdOrCasumoName = ko.observable().withFallback(session.id);

        self.trophiesHeading = adventureFieldFetcher('trophies_heading');

        self.adventurer = ko.pureComputed(function () {
            return adventurers.getByPlayerIdOrCasumoName(self.playerIdOrCasumoName());
        });

        self.adventure = ko.pureComputed(function () {
            return self.adventurer().getAdventure();
        });

        self.latestTrophy = ko.pureComputed(function () {
            return self.adventure().latestTrophies(1)[0];
        });

        self.openTrophiesDialog = function () {
            dialog.showDialog(new TrophiesDialog(self.adventure));
        };

    };

    TrophiesBlock.prototype.activate = function(settings) {
        var self = this;

        self.activateFallback = settings.activateFallback;

        self.latestTrophy.subscribeAndExec(function() {
            return self.activateFallback(_.isEmpty(self.latestTrophy()));
        });
    };

    return TrophiesBlock;
});

